"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var next_components_1 = require("@dotdev/next-components");
var UtilityLinks = /** @class */ (function (_super) {
    __extends(UtilityLinks, _super);
    function UtilityLinks(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            var linklist = _this.state.linklist;
            if (_this.props.data.customer != false) {
                linklist.links.push({ url: _this.state.wishlistLink, title: "Wishlist", handle: _this.state.wishlistHandle });
            }
        };
        _this.buildItems = function (links, style) {
            return links
                ? links.map(function (link, i) { return (React.createElement("a", { key: i, href: link.url, title: link.title, className: "flex text-ms md:ml-3-2 font-semibold text-arctic hover:text-grey transition-fast capitalize" },
                    React.createElement("span", null, link.handle.indexOf("wishlist") > -1 ? (React.createElement(Snippets.Svg, { name: "" + (_this.state.wishlistCount == 0 ? "star" : "star-active"), width: 16, className: "block mr-0-8 text-arctic" })) : null),
                    React.createElement("span", null, link.handle.indexOf("stores") > -1 ? React.createElement(Snippets.Svg, { name: "location", width: 16, className: "block mr-0-8" }) : null),
                    React.createElement("span", null, link.handle.indexOf("account") > -1 ? React.createElement(Snippets.Svg, { name: "user", width: 16, className: "block mr-0-8" }) : null),
                    React.createElement("span", null, link.handle.indexOf("contact") > -1 ? React.createElement(Snippets.Svg, { name: "contact", width: 16, className: "block mr-0-8" }) : null),
                    React.createElement("span", null, link.title))); })
                : [];
        };
        _this.buildLinks = function (links) {
            return links
                ? links.map(function (link, i) { return (React.createElement("li", { key: i, className: "mb-1" },
                    React.createElement("a", { href: link.url, title: link.title, className: "font-body text-base font-normal text-arctic hover:text-arctic-smoke transition-fast capitalize leading-normal" }, link.title))); })
                : [];
        };
        _this.state = {
            activeDropdown: null,
            wishlistLink: _this.props.data.section.header.settings.wishlist_url
                ? "/pages/" + _this.props.data.section.header.settings.wishlist_url
                : null,
            wishlistHandle: _this.props.data.section.header.settings.wishlist_url ? "" + _this.props.data.section.header.settings.wishlist_url : "",
            linklist: _this.props.linklist,
            wishlistCount: 0
        };
        return _this;
    }
    UtilityLinks.prototype.dropdown = function (link) {
        var newDropdown = this.state.activeDropdown === link ? null : link;
        this.setState({
            activeDropdown: newDropdown
        });
    };
    UtilityLinks.prototype.render = function () {
        var style = this.props.style;
        var linklist = this.state.linklist;
        return linklist && linklist.links && linklist.links.length ? (style == "small" ? (this.buildItems(linklist.links, style)) : (React.createElement("nav", { className: "md:w-2/3 w-full" },
            React.createElement("ul", { className: "w-full list-reset flex flex-col lg:flex-row justify-center" }, this.buildItems(linklist.links, style))))) : null;
    };
    UtilityLinks.contextType = next_components_1.ShopifyNext.Context;
    return UtilityLinks;
}(React.Component));
exports.UtilityLinks = UtilityLinks;
